import { render, staticRenderFns } from "./MiniGameWinningList.vue?vue&type=template&id=13ba89eb&"
import script from "./MiniGameWinningList.vue?vue&type=script&lang=js&"
export * from "./MiniGameWinningList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports